import axios from 'axios'

export default {

    /**
     * Send message to the site administrators
     *
     * @param data
     * @returns {AxiosPromise<any>}
     */
    send(data) {
        return axios.post('/api/contact', data)
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/contact.js